import TabPage from '@/components/TabPage';

export default function Campus() {
  return <TabPage chartFullKeys={['category']} />;
}
